import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../../nucleo/autorizacion/guardian.js';
import { rutaOperacion } from '../_operacion.js';

/**
 * La reapertura de una jornada y su recierre, pantalla 6d.
 *
 * ES LA PRIMERA HIJA DE `_operacion` CON GUARDIÁN PROPIO, y lo necesita: el grupo exige
 * `jornada.abrirCerrar`, que el operario tiene, y reabrir es `jornada.reabrir`, que la matriz de
 * la característica 2 le da sólo al jefe de operarios y al administrador. Sin esta segunda
 * exigencia el operario abriría una pantalla en la que cada botón le devuelve
 * `E_ROL_NO_AUTORIZADO`. El contador ya quedó fuera en el grupo.
 *
 * El `context` trae la sesión que devolvió el `beforeLoad` del grupo, así que esto no vuelve a
 * leerla: sólo pregunta por la acción.
 */
export const rutaReapertura = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/jornada/reapertura',
  beforeLoad: ({ context }) => ({ sesion: exigir(context, { accion: 'jornada.reabrir' }) }),
  component: lazyRouteComponent(
    () => import('../../funcionalidades/reapertura-jornada/PaginaReapertura.js'),
    'PaginaReapertura'),
});
